/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { Label, SVGIcon, Tooltip } from "@nordcloud/gnui";
import FlexContainer from "~/components/Styled/FlexContainer";

type LabelWithTooltipProps = {
  tooltipText: string;
  labelName: string;
  required?: boolean;
  position?: "left" | "right";
  htmlFor?: string;
};

const IconWrap = styled.div`
  transform: translateY(-0.1rem);
  padding-left: 0.5rem;
`;

function LabelWithTooltip({
  tooltipText,
  labelName,
  position,
  required,
  htmlFor,
}: LabelWithTooltipProps) {
  return (
    <Tooltip
      position={position}
      status="notification"
      caption={tooltipText}
      hideTimeout={0}
    >
      <FlexContainer>
        <Label htmlFor={htmlFor} name={labelName} required={required} />
        <IconWrap>
          <SVGIcon size="sm" name="info" />
        </IconWrap>
      </FlexContainer>
    </Tooltip>
  );
}

export { LabelWithTooltip };
